import { render, staticRenderFns } from "./SignTerms.vue?vue&type=template&id=08979a86&"
import script from "./SignTerms.vue?vue&type=script&lang=js&"
export * from "./SignTerms.vue?vue&type=script&lang=js&"
import style0 from "./SignTerms.vue?vue&type=style&index=0&id=08979a86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports